import React, { useState, useEffect } from "react";
import Styles from "./ShareDeveloper.module.css";
import { HiOutlineMail } from "react-icons/hi";
import { AiOutlineProduct } from "react-icons/ai";
import { FaLink } from "react-icons/fa6";
import { ImProfile } from "react-icons/im";
import { FaRegCircleUser } from "react-icons/fa6";

const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

export default function ShareDeveloper({ appData }) {
  const [developerEmail, setDeveloperEmail] = useState("");
  const [productName, setProductName] = useState("");
  const [senderName, setSenderName] = useState("");
  const [senderRole, setSenderRole] = useState("");
  const [integrationDocLink, setIntegrationDocLink] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  // Update live message when fields change
  useEffect(() => {
    const productText = productName ? `**${productName}**` : "product";
    const senderText = senderName
      ? ` from **${senderName}**${senderRole ? ` (${senderRole})` : ""}`
      : "";

    const defaultMessage = `Hi Dev Team,  

${senderName
        ? `${senderName}${senderRole ? ` (${senderRole})` : ""}`
        : "Someone"
      } has created an app for ${productText} using Sageion.com.

Hi Dev Team${senderText},  

I have created an app on sageion.com, which we apparently can use in our ${productText}.  

${integrationDocLink
        ? `You can access the integration documentation here: ${integrationDocLink}\n\n`
        : ""
      }
Can you please take a look into this suggested integration document below as per the version I have selected.

Note: Kindly let me know if the selected version is a mismatch for our production conditions. In that case we would need to delete this app and create a new one rather.

I will share the credentials of this app offline with the team.

Please Contact sageion.com for any support needed related to integration (https://sageion.com).`;

    setMessage(defaultMessage);
  }, [productName, senderName, senderRole, integrationDocLink]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });

    try {
      const payload = {
        email: developerEmail,
        email_type: "SHARE_DEVELOPER",
        data: {
          product_name: productName,
          sender_name: senderName,
          sender_role: senderRole,
          integration_doc_link: integrationDocLink,
          message_preview: message,
          app_data:
            { app_name: appData?.app_name, app_id: appData?.app_id } || {},
        },
      };

      const response = await fetch(
        `https://email2.${backend_api_base_url}/send_email`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer YOUR_API_KEY_HERE",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setStatus({
          type: "success",
          message: "Integration documentation sent successfully!",
        });
        setDeveloperEmail("");
      } else {
        setStatus({
          type: "error",
          message: data.message || "Failed to send email. Please try again.",
        });
      }
    } catch (error) {
      setStatus({
        type: "error",
        message: "Network error. Please check your connection and try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={Styles.container}>
      <h2 className={Styles.title}>Share Integration Documentation</h2>
      {/* Left section — form + app info */}
      <div className={Styles.shareDevWrap}>
        <div className={Styles.leftSection}>
          {/* <h2>Share Integration Documentation</h2> */}

          {appData && (
            <div className={Styles.appInfo}>
              <h3>App Information</h3>
              <div className={Styles.appDetails}>
                <div className={Styles.appDetailsContent}>
                  <strong>App Name:</strong>
                  <p>{appData.app_name}</p>
                </div>
                <div className={Styles.appDetailsContent}>
                  <strong>App ID:</strong>
                  <p>{appData.app_id}</p>
                </div>
              </div>
            </div>
          )}

          {status.message && (
            <div
              className={`${Styles.status} ${status.type === "success" ? Styles.success : Styles.error
                }`}
            >
              {status.message}
            </div>
          )}

          <form onSubmit={handleSubmit} className={Styles.form}>
            <div className={Styles.formWarp}>
              <div className={Styles.formGroup}>
                <label htmlFor="developerEmail" className={Styles.label}>
                  Developer Email:{" "}
                  <span className={Styles.requiredStar}>*</span>
                </label>
                <div className={Styles.inputWrapper}>
                  <input
                    type="email"
                    id="developerEmail"
                    value={developerEmail}
                    onChange={(e) => setDeveloperEmail(e.target.value)}
                    className={Styles.input}
                    placeholder="Enter developer email"
                    required
                  />
                  <HiOutlineMail className={Styles.inputIcon} />
                </div>
              </div>

              <div className={Styles.formGroup}>
                <label htmlFor="senderName" className={Styles.label}>
                  Your Name:
                </label>
                <div className={Styles.inputWrapper}>
                  <input
                    type="text"
                    id="senderName"
                    value={senderName}
                    onChange={(e) => setSenderName(e.target.value)}
                    className={Styles.input}
                    placeholder="Enter your name"
                  />

                  <FaRegCircleUser className={Styles.inputIcon} />
                </div>
                <div className={Styles.helpText}>
                  This will be highlighted in the message
                </div>
              </div>
            </div>

            <div className={Styles.formWarp}>
              <div className={Styles.formGroup}>
                <label htmlFor="senderRole" className={Styles.label}>
                  Your Role:
                </label>
                <div className={Styles.inputWrapper}>
                  <input
                    type="text"
                    id="senderRole"
                    value={senderRole}
                    onChange={(e) => setSenderRole(e.target.value)}
                    className={Styles.input}
                    placeholder="e.g., Product Manager, Team Lead"
                  />
                  <ImProfile className={Styles.inputIcon} />
                </div>

                <div className={Styles.helpText}>
                  Optional — adds context to your message
                </div>
              </div>

              <div className={Styles.formGroup}>
                <label htmlFor="productName" className={Styles.label}>
                  Product Name:
                </label>
                <div className={Styles.inputWrapper}>
                  <input
                    type="text"
                    id="productName"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                    className={Styles.input}
                    placeholder="Enter your product name"
                  />
                  <AiOutlineProduct className={Styles.inputIcon} />
                </div>

                <div className={Styles.helpText}>
                  This will be{" "}
                  <span className={Styles.highlightedText}>highlighted</span> in
                  the message
                </div>
              </div>
            </div>

            <div className={Styles.formGroup}>
              <label htmlFor="integrationDocLink" className={Styles.label}>
                Integration Document Link:
              </label>
              <div className={Styles.inputWrapper}>
                <input
                  type="url"
                  id="integrationDocLink"
                  value={integrationDocLink}
                  onChange={(e) => setIntegrationDocLink(e.target.value)}
                  className={Styles.input}
                  placeholder="https://docs.sageion.com/integration-guide"
                />
                <FaLink className={Styles.inputIcon} />
              </div>

              <div className={Styles.helpText}>
                Link to detailed integration documentation
              </div>
            </div>

            <button type="submit" className={Styles.button} disabled={loading}>
              {loading ? "Sending..." : "Share Integration Docs"}
            </button>
          </form>
        </div>

        {/* Right section — live message preview */}
        <div className={Styles.rightSection}>
          <h3>Message Preview</h3>
          <div className={Styles.messagePreview}>
            {message.split("\n").map((line, index) => {
              // const parts = line.split(/(\*\*.*?\*\*)/g);
              const parts = line.split(
                /(\*\*.*?\*\*|\bhttps?:\/\/sageion\.io\b|\bsageion\.com\b|\bSageion\.com\b)/g
              );

              return (
                <div key={index} className={Styles.messageLine}>
                  {parts.map((part, partIndex) => {
                    if (part.startsWith("**") && part.endsWith("**")) {
                      return (
                        <span
                          key={partIndex}
                          className={Styles.highlightedText}
                        >
                          {part.slice(2, -2)}
                        </span>
                      );
                    }
                    if (/^https?:\/\/sageion\.io$/i.test(part)) {
                      return (
                        <a
                          key={partIndex}
                          href="https://sageion.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          className={Styles.linkText}
                        >
                          {part}
                        </a>
                      );
                    }
                    if (/^sageion\.io$/i.test(part)) {
                      return (
                        <a
                          key={partIndex}
                          href="https://sageion.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          className={Styles.linkText}
                        >
                          {part}
                        </a>
                      );
                    }

                    return part;
                  })}
                </div>
              );
            })}
          </div>
          <div
            className={Styles.helpText}
            style={{ marginTop: "15px", fontSize: "15px", fontStyle: "italic" }}
          >
            This is how your email will appear to the developer.
          </div>
        </div>
      </div>
    </div>
  );
}
